import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { DRAWER_WIDTH } from "./constants";
import { BRAND_GRADIENT } from "@/constants/branding";

export default function AppLayout() {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <TopBar onMenuToggle={() => setMobileOpen((prev) => !prev)} />
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Toolbar sx={{ flexShrink: 0 }} />
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            p: { xs: 2, sm: 3 },
            overflow: "auto",
          }}
        >
          <Outlet />
        </Box>
        <Box
          component="footer"
          sx={{
            flexShrink: 0,
            py: 1.5,
            px: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: BRAND_GRADIENT,
            color: "#fff",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontWeight: 500,
              opacity: 0.85,
            }}
          >
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
